export default __webpack_public_path__ + "static/media/title.7a7d82e3.svg";